module.exports = __webpack_public_path__ + "static/media/46.f5e298b1.png";